/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_appsync_graphqlEndpoint": "https://6iz66mxltfdqpgahbipcxjigmq.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7wh3jgghyzappllcb2letufcia",
    "aws_cognito_identity_pool_id": "ap-southeast-1:00bf4443-212e-4d00-9377-2babf6871bd4",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_RnOOdhHrj",
    "aws_user_pools_web_client_id": "3690o2ruvgsn1ii0suvtj30a9a",
    "oauth": {}
};


export default awsmobile;
